import {http} from "./httpClient";

export const putUnique = (data) => http.put("legacy", "/unique", {data});
